export const GET_STATIC_DATA = "GET_STATIC_DATA";
export const SET_STATIC_DATA = "SET_STATIC_DATA";
